import { differenceInDays } from 'date-fns'

import i18n from 'modules/core/lib/i18n'

const formatNumber = (number: number): string => {
  const roundedNumber = parseFloat(number.toFixed(2))
  const decimal = roundedNumber.toFixed(2).split('.')[1]

  if (decimal?.charAt(0) !== '0') {
    return roundedNumber.toFixed(1).replace('.', ',')
  }

  return roundedNumber.toFixed(2).replace('.', ',')
}

export const getTimeLapseInYears = (date: string) => {
  const tenureDate = new Date(date)
  const currentDate = new Date()

  const daysDiff = differenceInDays(currentDate, tenureDate)
  const decimalDiff = daysDiff / 365

  const formattedYears = formatNumber(decimalDiff)
  const [number, decimals] = formattedYears.split(',')
  if (decimals === '00') {
    return number === '1'
      ? `${number} ${i18n.t('common.years.one')}`
      : `${number} ${i18n.t('common.years.other')}`
  }
  return `${formattedYears} ${i18n.t('common.years.other')}`
}
